import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IPostBody } from 'src/types/PostBody';
import { ScanManagerInvoiceItem } from 'src/types/ScanManagerInvoices';
import axiosInstance from 'src/utils/axios';

interface AttachDocumentRequest {
  body?: IPostBody;
}

interface AttachDocumentResponse {
  totalRecords: number;
  items: ScanManagerInvoiceItem[];
}

const useGetAttachmentsForReceiptApi = (companyId: number) => {
  const call = useCallback(
    ({ body }: AttachDocumentRequest = {}) =>
      new Promise<AttachDocumentResponse>((resolve, reject) => {
        axiosInstance
          .post<AttachDocumentResponse>(api.getScanManagerReceiptRecords, body, {
            params: { companyId },
          })
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [companyId]
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    getAttachedReceiptDocuments: execute,
    isAttachDocumentLoading: isLoading,
  };
};

export default useGetAttachmentsForReceiptApi;
